import {
  getEntraAccessToken,
  getEntraDisplayIdentity,
  isEntraAuthenticated,
  loginEntra,
  signOutEntra,
} from './entraAuth';
import {
  getStrataDisplayIdentity,
  getStrataIdToken,
  isStrataAuthenticated,
  signOutStrata,
} from './strataAuth';

export type PortalSessionKind = 'strata' | 'entra' | null;

export const getPortalSessionKind = async (): Promise<PortalSessionKind> => {
  if (await isStrataAuthenticated()) {
    return 'strata';
  }
  if (await isEntraAuthenticated()) {
    return 'entra';
  }
  return null;
};

export const isAuthenticated = async (): Promise<boolean> => {
  return (await getPortalSessionKind()) !== null;
};

export const getPortalBearerToken = async (): Promise<string | null> => {
  const kind = await getPortalSessionKind();
  if (kind === 'strata') {
    return getStrataIdToken();
  }
  if (kind === 'entra') {
    return getEntraAccessToken();
  }
  return null;
};

export const getCurrentUserIdentity = async (): Promise<string | null> => {
  const kind = await getPortalSessionKind();
  if (kind === 'strata') {
    return getStrataDisplayIdentity();
  }
  if (kind === 'entra') {
    return getEntraDisplayIdentity();
  }
  return null;
};

export const loginCustomer = async (): Promise<void> => {
  await loginEntra();
};

export const signOutUser = async (): Promise<void> => {
  const kind = await getPortalSessionKind();
  if (kind === 'strata') {
    await signOutStrata();
    return;
  }
  if (kind === 'entra') {
    await signOutEntra();
    return;
  }
};
